import stores from "@/stores"
import AppBridge from "@/utils/appBridge"
import { getSessionTokenWithFallback } from "@/utils/shopifySessionToken"

/**
 * 统一的Token获取工具类
 */
class TokenHelper {

  /**
   * 获取当前有效的认证token（带Bearer前缀）
   * 返回带Bearer前缀的token字符串
   */
  static async getToken(): Promise<string> {
    // 如果是从超管后台进入
    const { authToken } = stores.commonStore

    if (authToken) {
      return `Bearer ${authToken}`
    }

    // 如果是开发环境
    if (!AppBridge.exist()) {
      return `Bearer ${authToken || ""}` // 开发环境可能没有token，返回空Bearer
    }

    // 正常环境：使用 Shopify APP Bridge 获取token
    const token = await getSessionTokenWithFallback(AppBridge.app)

    return `Bearer ${token}`
  }

  /**
   * 检查当前环境类型
   */
  static getEnvironmentType(): "admin" | "development" | "shopify" {
    const { authToken } = stores.commonStore

    if (authToken) {
      return "admin"
    }

    if (!AppBridge.exist()) {
      return "development"
    }

    return "shopify"
  }
}

export default TokenHelper
